import { protectedAxiosInstance } from 'helpers/api-calls';
import { getLocaleCookie } from '../cookies';

const ROLE_TAG_TYPE = 'role';

/**
 * Gets all managable tags for current location.
 *
 * @param  { String | Int } {location_id}
 */
export const GetLocationRoles = (location_id) => {
  const locale = getLocaleCookie();

  return protectedAxiosInstance.request({
    url: `/api/customer/user_role/locations/${location_id}/tags/managable`,
    method: 'GET',
    headers: {
      Locale: locale,
    },
    params: {
      location_id,
      per_page: 1000,
      total: true,
    },
  });
};

/**
 * Gets demand data for current location.
 *
 * @param  { String | Int } {location_id}
 */
export const GetLocationDemandData = (location_id) => {
  const locale = getLocaleCookie();

  return protectedAxiosInstance.request({
    url: `/api/customer/user_role/locations/${location_id}/demands`,
    method: 'GET',
    headers: {
      Locale: locale,
    },
    params: {
      location_id,
    },
  });
};

export const DeleteRole = (tagId, locationId) => {
  return protectedAxiosInstance.request(
    {
      url: `api/customer/user_role/locations/${locationId}/tags/${tagId}`,
      method: 'DELETE',
    }
  );
}

export const AddRole = (name, colorCode, locationId)  => {
  // const locale = getLocaleCookie();

   const payload = {
      "tag": {
        "name": name,
        "tag_type": ROLE_TAG_TYPE,
        "color_code": colorCode,
      }
    };

  return protectedAxiosInstance.request(
    {
      url: `api/customer/user_role/locations/${locationId}/tags`,
      method: 'POST',
      // headers: {
      //   Locale: locale,
      // },
      data: payload
    }
  );
};

export const UpdateRole = (roleId, colorCode, locationId) => {
  const payload = {
    "tag": {
      "color_code": colorCode,
    }
  };
  return protectedAxiosInstance.request(
    {
      url: `api/customer/user_role/locations/${locationId}/tags/${roleId}`,
      method: 'PUT',
      data: payload
    }
  );
};

export const AssignRolesToUser = (userId, userRoleIds, locationId) => {
  const payload = {
    "tag_ids": userRoleIds,
  };
  return protectedAxiosInstance.request(
    {
      url: `api/customer/user_role/locations/${locationId}/assign_user_tags/${userId}`,
      method: 'PUT',
      data: payload
    }
  );
};

export const RemoveUserFromRole = (userId, userRoleIds, roleTagIdsToRemove, locationId) => {
  const resultArray = userRoleIds.filter( function( el ) {
    return !roleTagIdsToRemove.includes( el );
  });

  return AssignRolesToUser(userId, resultArray, locationId);
}

/**
 * Generates weekly demand data for a location using AI-powered curve generation.
 *
 * @param {String|Int} locationId - The location ID
 * @param {Object} payload - Generation configuration
 * @param {String} payload.curve_type - "realistic"|"flat"|"morning_peak"
 * @param {Object} payload.hours_of_operation - Per-day start/end hours
 */
export const GenerateWeeklyDemand = (locationId, payload) => {
  return protectedAxiosInstance.request({
    url: `/api/customer/admin_role/locations/${locationId}/demands/generate_demand`,
    method: 'POST',
    data: payload,
  });
};